import services from "@/services/index.js";
const path = '/ads';
export default {
    getAds: async () => {
        return await services.getAsync({ url: path, timeout: 10000, hasToken: true });
    },
    postAdsClick: async (body, adsUid, userUid) => {
        await services.postAsync({
            url: `${path}/${adsUid}/users/${userUid}`,
            body,
            timeout: 10000,
            hasToken: true
        });
    }
}